import type { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Lỗi của lần gửi vừa rồi, hiện **trong** hộp thoại và hộp không đóng: dữ liệu
 * vừa nhập còn nguyên để sửa. Cùng khuôn với `modules/tenant/components/phan-form.tsx`.
 */
export function LoiTrongHop({ children }: { children: ReactNode }) {
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded border border-danger-200 bg-danger-50 px-3 py-2.5"
    >
      <AlertTriangle size={15} className="mt-0.5 shrink-0 text-danger-600" />
      <span className="min-w-0 text-xs leading-relaxed text-danger-700">{children}</span>
    </div>
  );
}
